import { render, staticRenderFns } from "./RiskManager.vue?vue&type=template&id=3dff50b1"
import script from "./RiskManager.vue?vue&type=script&lang=js"
export * from "./RiskManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports